import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PubnubService } from '../services/Pubnub.service';
import { ActivatedRoute } from '@angular/router';
import { Map, getInstance, UserData, UserType } from 'nextnavsdknew';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-npr3ddemo',
  styleUrl: './npr3ddemo.component.css',  
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './npr3ddemo.component.html',
  standalone: false
})

export class Npr3ddemoComponent implements OnInit {
  uid: string;
  channelId: string;
  centreLat: any;
  centreLong: any;
  environment = environment;
  userLat: any;
  userLong: any;
  userHat: any;

  constructor(private http: HttpClient, private route: ActivatedRoute, private pubnub: PubnubService) {
    this.uid = this.route.snapshot.queryParams['uid'];
    this.channelId = this.route.snapshot.queryParams['channelId'] || this.route.snapshot.queryParams['channelid'];
    this.centreLat = this.route.snapshot.queryParams['centrelat'] || this.route.snapshot.queryParams['centreLat'];
    this.centreLong = this.route.snapshot.queryParams['centrelong'] || this.route.snapshot.queryParams['centreLong'];
    this.userLat = this.route.snapshot.queryParams['userlat'] || this.route.snapshot.queryParams['userLat'];
    this.userLong = this.route.snapshot.queryParams['userlong'] || this.route.snapshot.queryParams['userLong'];
    this.userHat = this.route.snapshot.queryParams['userhat'] || this.route.snapshot.queryParams['userHat'];
    if (this.userHat) {
      let regex = /(m|ft)$/;
      if (regex.test(this.userHat))
        this.userHat = this.userHat.split(regex)[1] == 'ft' ? this.userHat.split(regex)[0] * 0.3048 : this.userHat.split(regex)[0];

    }
    else {
      this.userHat = 1;
    }
  }
  svgToDataURL(svg: any) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  }
  createSVGIconWithText(text: any) {
    if (text == "")
      return `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#ffffff" stroke="#5EB2E1" stroke-width="1"/>
  <circle cx="12" cy="12" r="8" fill="#ff0000" stroke="#ff0000" stroke-width="1"/>
  </svg>
  `;
    else return `
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="9" fill="rgb(255, 255, 255)" stroke="black" stroke-width="1"/>
  <text x="5" y="16" fill="black" font-weight="bold" font-size="9" font-family="Verdana">` + text + `</text>
  </svg>
  `;
  }
  ngOnInit(): void {
    let defaultLat = 37.79131;
    let defaultLng = -122.41020;
    let firstLoad = true;
    var _this = this;
    let nextnavMap: any;
    // var pinnacleInterface = getInstance(CryptoJS.AES.decrypt(this.environment.API_KEY, '3DApp').toString(CryptoJS.enc.Utf8));
    var pinnacleInterface = getInstance('f5CWhIHdcN5EjXhLVUOmM9AeBihSQeXr8DHuLfjf');
    pinnacleInterface.on('load', function (event: any) {
      nextnavMap = new Map('container', {
        mapOptions: {
          //center: [0, 1],
          zoom: 18
        }
      });
    });
    // let fileContent = "";
    // document.addEventListener("click", (event) => {
    //   const blob = new Blob([fileContent], { type: "text/plain" });
    //   const a = document.createElement("a");
    //   a.href = URL.createObjectURL(blob);
    //   a.download = "file.txt";
    //   a.click();
    // })

    if (_this.channelId) {
      _this.pubnub.showCasePubnumInstantiateAndSubscribe(environment.mob2cadpubKey, environment.mob2cadsubkey, _this.channelId, _this.uid ? _this.uid : 'Test');
      // _this.pubnub.publish(_this.channelId, {"name":"rohit"});
      let position: any = {};
      _this.pubnub.addObserver(_this.channelId).subscribe(async (obj: any) => {
        if (obj.message) {
          if (obj.publisher == "myUniqueUser_Id") {
            let splitStr = obj.message.split(',');
            let hat = await _this.getEFlValue(parseFloat(splitStr[10]), parseFloat(splitStr[11]), parseFloat(splitStr[12]), parseFloat(splitStr[13]), parseFloat(splitStr[14]));
            obj.message = { device_id: obj.publisher, timestamp: splitStr[1], latitude: parseFloat(splitStr[10]), longitude: parseFloat(splitStr[11]), heightAboveTerrain: hat, isLocationUserPinned: false }
          }
          else if (obj.publisher == "myTruth_Id") {
            let splitStr = obj.message.split(',');
            let hat = await _this.getEFlValue(parseFloat(splitStr[3]), parseFloat(splitStr[4]), parseFloat(splitStr[5]), 6.6, 0.4);
            obj.message = { device_id: obj.publisher, timestamp: splitStr[2], latitude: parseFloat(splitStr[3]), longitude: parseFloat(splitStr[4]), heightAboveTerrain: hat, isLocationUserPinned: false }
          }
          // else if (obj.publisher == "mobile-uts" || obj.publisher == "b857e404430fa5205fb2b413948327fa92ed104d6edece4fefa196fbe7225146") {
          //   let hat = await _this.getEFlValue(obj.message.location2d.latitude, obj.message.location2d.longitude, obj.message.height, obj.message.location2d.xyUnc, obj.message.heightUncertainty);
          //   obj.message = { device_id: obj.publisher, timestamp: obj.message.timestamp, latitude: obj.message.location2d.latitude, longitude: obj.message.location2d.longitude, heightAboveTerrain: hat, isLocationUserPinned: false }
          // }
          else {
            // obj.publisher = "mobile-uts";
            let hat = await _this.getEFlValue(obj.message.location2d.latitude, obj.message.location2d.longitude, obj.message.height, obj.message.location2d.xyUnc, obj.message.heightUncertainty);
            obj.message = { device_id: obj.publisher, timestamp: obj.message.timestamp, latitude: obj.message.location2d.latitude, longitude: obj.message.location2d.longitude, heightAboveTerrain: hat, isLocationUserPinned: false }
          }
        }
        if (pinnacleInterface.isLoaded) {
          if (firstLoad) {
            if (_this.centreLat && _this.centreLong)
              pinnacleInterface.setMapLocation({ lat: Number(_this.centreLat), lng: Number(_this.centreLong), zoom: 18, orientation: 0 });
            else
              if (obj.message) if (obj.message.latitude && obj.message.longitude)
                pinnacleInterface.setMapLocation({ lat: Number(obj.message.latitude), lng: Number(obj.message.longitude), zoom: 18, orientation: 0 });
            firstLoad = false;
          }
          // let userType = (obj.publisher == 'myUniqueUser_Id' ? 7 : (obj.publisher == 'mobile-uts' || obj.publisher == "b857e404430fa5205fb2b413948327fa92ed104d6edece4fefa196fbe7225146") ? 8 : obj.publisher == 'myTruth_Id' ? 9 : 6);
          let userType = (obj.publisher == 'myUniqueUser_Id' ? 7 : obj.publisher == 'myTruth_Id' ? 9 : 8);
          if (obj.message && obj.message.device_id) {
            let img = null;
            let userTypeEnum = null;
            if (userType == 2) {
              img = './assets/police.png';
              userTypeEnum = UserType.POLICE;
            }
            else if (userType == 1) {
              img = './assets/firefighter.png';
              userTypeEnum = UserType.FIREFIGHTER;
            }
            else if (userType == 3) {
              img = './assets/ems.png';
              userTypeEnum = UserType.EMS;
            }
            else if (userType == 4) {
              img = './assets/security.png';
              userTypeEnum = UserType.SECURITY;
            }
            else if (userType == 5) {
              img = './assets/e911caller.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.E911USER;
            }
            else if (userType == 7) {
              img = './assets/nextgen.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.NEXTGEN;
            }
            else if (userType == 8) {
              img = './assets/gps.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.GPS;
            }
            else if (userType == 9) {
              img = './assets/groundtruth.png';//_this.svgToDataURL(_this.createSVGIconWithText(""));
              userTypeEnum = UserType.GROUNDTRUTH;
            }
            else {
              img = './assets/man.png';
              userTypeEnum = UserType.OTHER;
            }
            if (!position[obj.message.device_id]) {
              position[obj.message.device_id] = new UserData({
                id: userType == 7 ? 'nextgen' : userType == 8 ? 'gps' : userType == 9 ? 'groundtruth' : obj.message.device_id,
                userType: userTypeEnum, imgPath: img, lat: obj.message.latitude,
                lng: obj.message.longitude,
                hat: obj.message.heightAboveTerrain ? obj.message.heightAboveTerrain : 0,
                // efl: 0,
                firstName: obj.message.device_id,
                lastName: '',
                timestamp: obj.message.timestamp ? obj.message.timestamp : 0
              });
              pinnacleInterface.addUser(position[obj.message.device_id]);
            }

            if (position[obj.message.device_id]) {
              if (obj.message && obj.message.latitude && obj.message.longitude) {
                obj.message.heightAboveTerrain = obj.message.heightAboveTerrain ? obj.message.heightAboveTerrain : 0;
                if (isFinite(obj.message.latitude) && Math.abs(obj.message.latitude) <= 90 && Math.abs(obj.message.longitude) <= 180 && Math.abs(obj.message.longitude) <= 180 && isFinite(obj.message.heightAboveTerrain)) {
                  pinnacleInterface.updateUserLocation({
                    id: userType == 7 ? 'nextgen' : userType == 8 ? 'gps' : userType == 9 ? 'groundtruth' : obj.message.device_id,
                    lat: obj.message.latitude,
                    lng: obj.message.longitude,
                    hat: obj.message.isLocationUserPinned ? 1 : obj.message.heightAboveTerrain,
                    // efl: 0,
                    userType: userTypeEnum,
                    imgPath: img,
                    // firstName: obj.message.firstName,
                    // lastName: obj.message.lastName,
                    timestamp: obj.message.timestamp
                  });
                }
              }
            }
          }
          // console.log(obj.timeout);
          // if (obj.timeout) {
          //   if (position && position[obj.publisher]) {
          //     pinnacleInterface.removeUser(obj.publisher);
          //     delete position[obj.publisher];
          //   }
          // }
        }
      });
    }
    else if (_this.userLat && _this.userLong) {
      if (firstLoad) {
        pinnacleInterface.on('load', async function (event: any) {
          pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : Number(_this.userLat), lng: _this.centreLong ? Number(_this.centreLong) : Number(_this.userLong), zoom: 18, orientation: 200 });
          nextnavMap.on('load', async function (event: any) {
            pinnacleInterface.addUser(new UserData({
              id: 'id',
              userType: UserType.OTHER,
              imgPath: './assets/man.png',
              lat: Number(_this.userLat),
              lng: Number(_this.userLong),
              hat: Number(_this.userHat ? _this.userHat : 1),
              // efl: Math.round(_this.userHat / 3),
              firstName: "Guest", lastName: "User"
            }));
          });
        });
        firstLoad = false;
      }
    }
    setTimeout(function () {
      if (firstLoad) {
        if (pinnacleInterface.isLoaded)
          pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 0 });
        else
          pinnacleInterface.on('load', function (event: any) {
            pinnacleInterface.setMapLocation({ lat: _this.centreLat ? Number(_this.centreLat) : defaultLat, lng: _this.centreLong ? Number(_this.centreLong) : defaultLng, zoom: 18, orientation: 0 });
          });
        firstLoad = false;
      }
    }, 5000);
  }

  async getEFlValue(lat: any, lng: any, z: any, xyUncertainty: any, zUncertainty: any) {
    // const url = 'https://pinnacle.nextnavapis.io/v2/hae-to-hat';
    // const headers = new HttpHeaders({
    //   'x-api-key': '6OpDRM6Aep2Rm4dqlgQD236amTphhqa2aezg9qi7',
    //   'Content-Type': 'application/json',
    // });
    // const url = 'https://dev.nextnav.io/gs/v2/hae-to-hat';
    // const headers = new HttpHeaders({
    //   'x-api-key': '9PUArYRvwCiyMNAfqzkH91CyYHJ90kY6QzzW1nI3',
    //   'Content-Type': 'application/json',
    // });
    const url = environment.hae2hatapi;
    const headers = new HttpHeaders({
      'x-api-key': environment.hae2hatkey,
      'Content-Type': 'application/json',
    });

    const requestBody = {
      xyLocation: {
        latitude: lat,
        longitude: lng,
        xyUncertainty: xyUncertainty,
        xyConfidence: 'CONF68',
      },
      zInput: {
        zValue: z,
        zUncertainty: zUncertainty,
        zType: 'HAE',
        zConfidence: 'CONF68',
      },
    };

    try {
      const response: any = await this.http.post(url, requestBody, { headers }).toPromise();
      if (response.status == 'N200')
        return response.hat.zValue;
      else
        return Number.NaN;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}
